export default __webpack_public_path__ + "static/media/label.1ae96c9c.png";